import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import { get } from 'lodash';
import EllipsisDropdown from '../elements-dropdown/EllipsisDropdown';

class AddOnCard extends Component {
  constructor (props) {
    super(props);

    this.handleClickDelete = this.handleClickDelete.bind(this);
    this.handleClickEdit = this.handleClickEdit.bind(this);
    this.handleClickViewAddOn = this.handleClickViewAddOn.bind(this);
  }

  handleClickDelete () {
    const { index, deleteAddOn } = this.props;

    deleteAddOn(index);
  }

  handleClickEdit () {
    const { item, index, openEditBookingAddOnModal } = this.props;
    openEditBookingAddOnModal(item._id, index);
  }

  handleClickViewAddOn () {
    const { itemSelected, getInventoryItem, viewAddOnDetailsAction } = this.props;

    getInventoryItem(itemSelected._id);
    viewAddOnDetailsAction(itemSelected._id);
  }

  render () {
    const {
      item = {},
      currency,
      hasMaxQuantity,
      ssoId,
      itemContract
    } = this.props;
    const cost = Number(item.unit_cost).toFixed(2);
    const amount = get(itemContract, 'primary_amount', {});
    const addOnAmount = (0 === amount[ssoId] || amount[ssoId]) ? amount[ssoId].toFixed(2) : null;
    const listItems = [
      {
        title: this.props.intl.formatMessage({ id: 'inbox.add_on_card.details', defaultMessage: 'View details' }),
        onClick: this.handleClickViewAddOn,
        testingId: 'view-option'
      },
      {
        title: this.props.intl.formatMessage({ id: 'inbox.add_on_card.edit', defaultMessage: 'Edit add on' }),
        onClick: this.handleClickEdit,
        testingId: 'edit-option'
      },
      {
        title: this.props.intl.formatMessage({ id: 'inbox.add_on_card.delete', defaultMessage: 'Delete' }),
        onClick: this.handleClickDelete,
        className: 'option-delete',
        testingId: 'delete-option'
      }
    ];

    return (
      <div className="add-on-card d-sm-none">
        <div className="flex space-between">
          <h5>{item.label}</h5>
          <EllipsisDropdown
            listItems={listItems}
            pullRight
          />
        </div>

        <hr />

        <div className="quantity-section flex space-between">
          <div className="label">
            <FormattedMessage
              id='inbox.add_on_card.quantity'
              defaultMessage='Quantity'
            />
          </div>
          <div>
            {
              hasMaxQuantity ?
                item.count : 0
            }
          </div>
        </div>

        <div className="price-section flex space-between">
          <div className="label">
            <FormattedMessage
              id='inbox.add_on_card.price'
              defaultMessage='Price'
            />
          </div>
          <div>
            <FormattedNumber value={cost} currency={currency} style={'currency'} />&nbsp;
            <FormattedMessage
              id='inbox.add_on_card.item'
              defaultMessage='/item'
            />
          </div>
        </div>

        <hr className="dotted" />

        <div className="amount-section flex space-between">
          <div className="label">
            <FormattedMessage
              id='inbox.add_on_card.amount'
              defaultMessage='Amount'
            />
          </div>
          <div>
            <FormattedNumber value={addOnAmount} currency={currency} style={'currency'} />
          </div>
        </div>
      </div>
    );
  }
}

AddOnCard.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  itemSelected: PropTypes.object,
  currency: PropTypes.string,
  deleteAddOn: PropTypes.func,
  viewAddOnDetailsAction: PropTypes.func,
  getInventoryItem: PropTypes.func,
  openEditBookingAddOnModal: PropTypes.func,
  hasMaxQuantity: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  itemContract: PropTypes.object,
  ssoId: PropTypes.string,
  intl: intlShape
};

export default injectIntl(AddOnCard);
